import { useSyncExternalStore } from 'react';
import {
  RenderSettings,
  getSavedRenderSettings,
  isPreviewingRenderSettings,
  onRenderSettingsChange,
} from '../../ui/room3d/renderSettings';

/** The saved render settings (what the controls show and edit), re-rendering when they change. */
export function useRenderSettings(): RenderSettings {
  return useSyncExternalStore(onRenderSettingsChange, getSavedRenderSettings);
}

/** True while a look is being shown temporarily (Compare held down). */
export function useRenderPreviewing(): boolean {
  return useSyncExternalStore(onRenderSettingsChange, isPreviewingRenderSettings);
}
